import * as React from "react";
import { Label, SemanticSIZES } from "semantic-ui-react";
import { COLORS } from "../../../constants";
import { ColorProp } from "../../../constants/type";
import { getColor } from "../../../utils/get-color";
export interface IText {
  size?: SemanticSIZES;
  shade?: ColorProp;
  underline?: boolean;
  children: any;
  style?: any;
  className?: any;
  href?: any;
  highlight?: boolean;
}

class Text extends React.Component<IText> {
  public render() {
    const { highlight } = this.props;
    return (
      highlight ?
        <div style={styles.highlightDivStyle}>
          {this.renderLabel()}
        </div>
        :
        this.renderLabel()
    );
  }

  private renderLabel = () => {
    const { size, underline, href, style, highlight, className, children, ...rest } = this.props;
    const textColor = this.textColor();
    const textSize: any = this.textSize();
    return (
      <Label
        href={href}
        {...rest}
        className={`label-text ${className}`}
        style={{
          color: textColor,
          textDecoration: underline ? "underline" : "none",
          ...styles.label,
          ...style,
        }}
        size={textSize}
      >
        {children}
      </Label>
    );
  }

  private textColor = () => {
    const { shade } = this.props;

    return getColor(shade);
  };
  private textSize = () => {
    const { size } = this.props;
    return size || "large";
  }
}

const styles = {
  label: {
    // marginBottom: 6,
    // margin: 0,
    // padding: 0,
    // backgroundColor: "transparent",
  },
  highlightDivStyle: {
    display: "inline",
    backgroundColor: COLORS.lightYellow,
    padding: 3,
  },
};

export default Text;
